<template>
  <div>
    <Assistant_teacher_bar />

    <v-container fluid>
      <!-- Header -->
      <v-row>
        <v-col cols="12">
          <v-card class="mb-4">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-account-tie</v-icon>
              ระบบจัดการข้อมูลครูผู้ช่วย
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>

      <!-- Filter Section -->
      <v-row>
        <v-col cols="12">
          <v-card class="mb-4">
            <v-card-title>
              <v-icon left>mdi-filter</v-icon>
              ตัวกรองข้อมูล
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    v-model="filters.mt_appoin_day"
                    label="วันแต่งตั้ง"
                    type="number"
                    min="1"
                    max="31"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    v-model="filters.mt_appoin_month"
                    label="เดือนแต่งตั้ง"
                    type="number"
                    min="1"
                    max="12"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    v-model="filters.mt_appoin_year"
                    label="ปีแต่งตั้ง"
                    type="number"
                    min="2020"
                    max="2030"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="filters.mt_id_card"
                    label="เลขประจำตัวประชาชน"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-btn
                    color="primary"
                    @click="applyFilters"
                    :loading="loading"
                    block
                  >
                    <v-icon left>mdi-magnify</v-icon>
                    ค้นหา
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6" md="1">
                  <v-btn color="secondary" @click="clearFilters" outlined block>
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Data Table -->
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              รายชื่อครูผู้ช่วย
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="assistantTeachers"
              :search="search"
              :loading="loading"
              class="elevation-1"
              :items-per-page="10"
            >
              <template v-slot:item.mt_type_personnel="{ item }">
                <div v-if="item.mt_type_personnel === 'local_dev'">
                  <v-chip color="info" dark>ครูพัฒนาท้องถิ่น</v-chip>
                </div>
                <div v-else-if="item.mt_type_personnel === 'transfer_position'">
                  <v-chip color="warning" dark>ครูโอนย้าย</v-chip>
                </div>
                <div v-else>
                  <v-chip color="success" dark>ปกติ</v-chip>
                </div>
              </template>

              <template v-slot:item.pt_licence="{ item }">
                <div v-if="item.mt_license_status === 'have'">
                  <v-icon color="info" size="30"
                    >mdi-card-account-details-star</v-icon
                  >
                </div>

                <div v-else-if="item.mt_license_status === 'donot'">
                  (P License)
                  <v-icon color="warning" size="30"
                    >mdi-card-bulleted-off</v-icon
                  >

                  <div v-if="item.pt_licence_tem">
                    <div v-if="String(item.pt_licence_file_tem).length < 10">
                      <v-chip color="error" outlined>
                        <v-icon>mdi-alert</v-icon> ไม่ได้แนบไฟล์
                      </v-chip>
                    </div>
                    <div v-else>
                      <v-chip
                        @click="viewpdflicenseteach(item.pt_licence_file_tem)"
                        outlined
                        color="info"
                      >
                        <v-icon>mdi-magnify</v-icon>
                        {{ item.pt_licence_tem }}</v-chip
                      >
                    </div>
                    หมดอายุวันที่ <br />
                    {{
                      item.pt_enddate_tem
                        | moment("add", "543 year")
                        | moment("D MMMM YYYY")
                    }}
                    <div
                      v-if="item.datediffendtem <= 0"
                      class="red--text font-weight-bold"
                    >
                      <v-icon color="red" size="30">mdi-alert</v-icon>
                      <br />
                      หมดก่อน {{ item.datediffendtem }} วัน
                    </div>
                  </div>
                  <div v-else>
                    <v-chip color="error" outlined>
                      <v-icon>mdi-alert</v-icon> ไม่ได้แนบไฟล์
                    </v-chip>
                  </div>
                </div>

                <div
                  v-else-if="item.mt_license_status === 'waitpl'"
                  class="red--text"
                >
                  ขอ (P License) <br />
                  <v-icon color="error" size="30">mdi-card-bulleted-off</v-icon>
                </div>

                <div
                  v-else-if="item.mt_license_status === 'anything'"
                  class="warning--text"
                >
                  (P License) <br />
                  <v-icon color="error" size="30">mdi-card-bulleted-off</v-icon>
                </div>

                <div v-if="item.pt_licence_file_ipa === 'pass'">
                  <v-icon color="success">mdi-check-circle</v-icon>
                </div>

                <div
                  v-else-if="item.pt_licence_file_ipa === 'dontpass'"
                  class="red--text"
                >
                  {{ item.pt_licence_file_ipacomment }}
                </div>

                <div v-if="item.pt_licence">
                  <div v-if="String(item.pt_licence_file).length < 10">
                    <v-chip color="error" outlined>
                      <v-icon>mdi-alert</v-icon> ไม่ได้แนบไฟล์
                    </v-chip>
                  </div>
                  <div v-else>
                    <v-chip
                      @click="viewpdflicenseteach(item.pt_licence_file)"
                      outlined
                      color="info"
                    >
                      <v-icon>mdi-magnify</v-icon>
                      {{ item.pt_licence }}</v-chip
                    >
                  </div>
                  หมดอายุวันที่ <br />
                  {{
                    item.pt_enddate
                      | moment("add", "543 year")
                      | moment("D MMMM YYYY")
                  }}
                  <div
                    v-if="item.datediffend <= 0"
                    class="red--text font-weight-bold"
                  >
                    <v-icon color="red" size="30">mdi-alert</v-icon> <br />
                    หมดก่อน {{ item.datediffend }} วัน
                  </div>
                </div>
              </template>

              <template v-slot:item.approve_level1="{ item }">
                <div>
                  <v-btn @click="approveTeach_id(item)" color="success" rounded
                    >อนุมัติ</v-btn
                  >
                </div>
              </template>
              <template v-slot:item.pt_licence_ict="{ item }">
                <v-icon color="green" v-if="item.pt_licence_ict === 'ict'"
                  >mdi-check-circle</v-icon
                >
                <v-icon color="red" v-else>mdi-close</v-icon>
              </template>

              <template v-slot:item.mt_time_1_score="{ item }">
                <div v-if="item.mt_time_1_ck === 'Pass'">
                  <v-btn color="success" icon small>
                    <v-icon>mdi-check-circle</v-icon>
                  </v-btn>
                </div>

                <v-chip
                  v-if="item.mt_time_1_score > 0"
                  color="info"
                  @click="viewFileScore((param = item.mt_time_1_file))"
                >
                  <span class="font-weight-bold yellow--text">{{
                    item.mt_time_1_score
                  }}</span>
                </v-chip>
              </template>

              <template v-slot:item.mt_time_2_score="{ item }">
                <div v-if="item.mt_time_2_ck === 'Pass'">
                  <v-btn color="success" icon small>
                    <v-icon>mdi-check-circle</v-icon>
                  </v-btn>
                </div>

                <v-chip
                  v-if="item.mt_time_2_score > 0"
                  color="info"
                  @click="viewFileScore((param = item.mt_time_2_file))"
                >
                  <span class="font-weight-bold yellow--text">{{
                    item.mt_time_2_score
                  }}</span>
                </v-chip>
              </template>

              <template v-slot:item.mt_time_3_score="{ item }">
                <div v-if="item.mt_time_3_ck === 'Pass'">
                  <v-btn color="success" icon small>
                    <v-icon>mdi-check-circle</v-icon>
                  </v-btn>
                </div>
                <v-chip
                  v-if="item.mt_time_3_score > 0"
                  color="info"
                  @click="viewFileScore((param = item.mt_time_3_file))"
                >
                  <span class="font-weight-bold yellow--text">{{
                    item.mt_time_3_score
                  }}</span>
                </v-chip>
              </template>

              <template v-slot:item.mt_time_4_score="{ item }">
                <div v-if="item.mt_time_4_ck === 'Pass'">
                  <v-btn color="success" icon small>
                    <v-icon>mdi-check-circle</v-icon>
                  </v-btn>
                </div>
                <v-chip
                  v-if="item.mt_time_4_score > 0"
                  color="info"
                  @click="viewFileScore((param = item.mt_time_4_file))"
                >
                  <span class="font-weight-bold yellow--text">{{
                    item.mt_time_4_score
                  }}</span>
                </v-chip>
              </template>

              <template v-slot:item.assistant_teacher_re_status="{ item }">
                <div v-if="item.assistant_teacher_re_status === 'CC'">
                  <v-icon size="30" color="red"> mdi-alert</v-icon>
                </div>
                <div
                  v-else-if="
                    String(item.assistant_teacher_re_leaveguarantee).length > 4
                  "
                >
                  <v-icon size="30" color="success">mdi-check-circle</v-icon>
                </div>
              </template>

              <template
                v-slot:item.assistant_teacher_re_leaveguarantee="{ item }"
              >
                <div
                  v-if="
                    String(item.assistant_teacher_re_leaveguarantee).length > 4
                  "
                >
                  <v-btn
                    @click="
                      viewFileleavegurantee(
                        item.assistant_teacher_re_leaveguarantee
                      )
                    "
                    fab
                    small
                    color="info"
                  >
                    <v-icon size="30">mdi-printer</v-icon>
                  </v-btn>
                </div>
              </template>

              <template
                v-slot:item.assistant_teacher_re_status_detail="{ item }"
              >
                <div
                  v-if="item.assistant_teacher_re_status === 'CC'"
                  class="red--text"
                >
                  {{ item.assistant_teacher_re_status_detail }}
                </div>
              </template>

              <template v-slot:item.evaluate_s="{ item }">
                <v-chip
                  color="green"
                  dark
                  v-if="item.report_id_card === item.id_card"
                >
                  <h2>
                    <v-icon>mdi-checkbox-marked-circle</v-icon> ส่งผลการประเมิน
                  </h2>
                </v-chip>
                <v-chip
                  v-else-if="
                    item.last_time_ass === '1' ||
                      item.last_time_ass === '2' ||
                      item.last_time_ass === '3' ||
                      item.last_time_ass === '4'
                  "
                  color="info"
                  @click.stop="evaluate_assistant(item.mt_id_card)"
                  dark
                >
                  <h2>{{ item.last_time_ass }}</h2>
                </v-chip>
                <v-chip
                  v-else
                  dark
                  color="red"
                  @click.stop="evaluate_assistant(item.mt_id_card)"
                >
                  <h2>
                    <v-icon class="pa-1">mdi-cursor-pointer</v-icon>
                    ไม่ได้เริ่มประเมิน
                  </h2>
                </v-chip>
              </template>

              <template v-slot:item.prints="{ item }">
                <v-chip
                  color="info"
                  dark
                  v-if="item.report_id_card === item.id_card"
                >
                  <h2><v-icon>mdi-printer</v-icon> พิมพ์รายงาน</h2>
                </v-chip>
                <v-chip
                  v-else-if="
                    item.last_time_ass === '1' ||
                      item.last_time_ass === '2' ||
                      item.last_time_ass === '3' ||
                      item.last_time_ass === '4'
                  "
                  color="info"
                  dark
                >
                  <h2>อยู่ระหว่างการประเมิน</h2>
                </v-chip>
                <v-chip v-else color="red" dark>
                  <h2>ไม่ได้เริ่มประเมิน</h2>
                </v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon
                  color="yellow"
                  @click.stop="assistant_teacher_reportEdit(item.id_rc)"
                >
                  mdi-pencil
                </v-icon>
              </template>

              <template v-slot:item.cancels="{ item }">
                <v-icon color="red" @click.stop="cancelApproveTeach_id(item)">
                  mdi-cancel
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>

      <!-- Details Dialog -->
      <v-dialog v-model="detailsDialog" max-width="800px">
        <v-card>
          <v-card-title>
            <span class="text-h5">รายละเอียดครูผู้ช่วย</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="detailsDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text v-if="selectedTeacher">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="ชื่อ"
                  :value="selectedTeacher.mt_frist_name"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="นามสกุล"
                  :value="selectedTeacher.mt_last_name"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="เลขประจำตัวประชาชน"
                  :value="selectedTeacher.mt_id_card"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="เบอร์โทรศัพท์"
                  :value="selectedTeacher.mt_tel_p"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="วุฒิการศึกษา"
                  :value="selectedTeacher.mt_ed_name"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-layout row justify-center>
        <v-dialog v-model="pdflicenseteachdialog" max-width="80%">
          <v-card class="" elevation="2">
            <embed
              :src="
                'https://hrvec.ovec.go.th/HRvecLicenseTeach/' + pt_licence_files
              "
              width="100%"
              height="700px"
            />
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="scoredialog" max-width="80%">
          <v-card class="" elevation="2">
            <embed
              :src="'https://hrvec.ovec.go.th/HRvecfiles/' + assFileScore"
              width="100%"
              height="700px"
            />
          </v-card>
        </v-dialog>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog
          v-model="assistant_teacher_re_leaveguaranteedialog"
          max-width="80%"
        >
          <v-card class="" elevation="2">
            <embed
              :src="
                'https://hrvec.ovec.go.th/HRvecAssistant_report/' +
                  assistant_teacher_re_leaveguarantee
              "
              width="100%"
              height="700px"
            />
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Assistant_teacher_bar from "../../../components/admin/assistant_teacher_bar.vue";

export default {
  name: "AssistantTeacherDashboard",
  components: {
    Assistant_teacher_bar
  },
  data() {
    return {
      loading: true,
      search: "",
      ApiKey: "HRvec2021",
      // Filter parameters to match your PHP API
      filters: {
        mt_appoin_day: null,
        mt_appoin_month: null,
        mt_appoin_year: null,
        mt_id_card: null,
        mt_type_personnel: null
      },
      detailsDialog: false,
      selectedTeacher: null,
      assistantTeachers: [],
      headers: [
        { text: "ลำดับ", align: "center", value: "order_number" },
        { text: "ประเภท", align: "left", value: "mt_type_personnel" },
        { text: "รหัสสถานศึกษา", align: "left", value: "mt_college_code" },
        { text: "สถานศึกษา", align: "left", value: "user_firstname" },
        { text: "รหัสบัตรประชาชน", align: "left", value: "mt_id_card" },
        { text: "ชื่อ-นามสกุล", align: "left", value: "frist_names" },
        { text: "เลขที่ตำแหน่ง", align: "center", value: "mt_id_position" },
        { text: "ใบประกอบวิชาชีพ", align: "center", value: "pt_licence" },
        { text: "คุรุสภา", align: "center", value: "pt_licence_ict" },
        { text: "ครั้งที่ 1", align: "center", value: "mt_time_1_score" },
        { text: "ครั้งที่ 2", align: "center", value: "mt_time_2_score" },
        { text: "ครั้งที่ 3", align: "center", value: "mt_time_3_score" },
        { text: "ครั้งที่ 4", align: "center", value: "mt_time_4_score" },

        {
          text: "ไฟล์รับรองวันลา",
          align: "center",
          value: "assistant_teacher_re_leaveguarantee"
        },

        {
          text: "สถานะ",
          align: "center",
          value: "assistant_teacher_re_status"
        },
        { text: "วันเดือนปีบรรจุ", align: "center", value: "mt_date_app_now" },
        { text: "คำสั่งที่", align: "center", value: "mt_order_app" },
        {
          text: "วันที่รายงาน",
          align: "center",
          value: "assistant_teacher_re_datetime"
        },
        {
          text: "ยกเลิก คศ.1",
          align: "center",
          value: "cancels",
          icon: "mdi-cancel"
        }
      ],
      // Chart Options
      statusChartOptions: {
        chart: {
          type: "pie"
        },
        labels: ["ใช้งาน", "ไม่ใช้งาน", "รอดำเนินการ"],
        colors: ["#4CAF50", "#F44336", "#FF9800"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      },
      statusChartSeries: [0, 0, 0],
      educationChartOptions: {
        chart: {
          type: "donut"
        },
        labels: ["ปริญญาตรี", "ปริญญาโท", "ปริญญาเอก", "อื่นๆ"],
        colors: ["#2196F3", "#9C27B0", "#FF5722", "#607D8B"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      },
      educationChartSeries: [0, 0, 0, 0],
      appointmentTrendOptions: {
        chart: {
          type: "line",
          height: 350
        },
        stroke: {
          curve: "smooth",
          width: 3
        },
        colors: ["#2196F3"],
        xaxis: {
          categories: []
        },
        yaxis: {
          title: {
            text: "จำนวนการแต่งตั้ง"
          }
        },
        title: {
          text: "แนวโน้มการแต่งตั้งครูผู้ช่วยรายปี",
          align: "left"
        }
      },
      appointmentTrendSeries: [
        {
          name: "การแต่งตั้ง",
          data: []
        }
      ],
      user_id: [],
      pt_licence_files: "",
      pdflicenseteachdialog: false,
      assFileScore: "",
      scoredialog: false,
      assistant_teacher_re_leaveguarantee: "",
      assistant_teacher_re_leaveguaranteedialog: false
    };
  },
  computed: {
    totalTeachers() {
      return this.assistantTeachers.length;
    },
    activeTeachers() {
      return this.assistantTeachers.filter(teacher => teacher.mt_status === "1")
        .length;
    },
    licensedTeachers() {
      return this.assistantTeachers.filter(
        teacher => teacher.mt_license_status === "1"
      ).length;
    },
    collegeCount() {
      const colleges = new Set(
        this.assistantTeachers.map(teacher => teacher.mt_college_code)
      );
      return colleges.size;
    }
  },
  async mounted() {
    await this.userQueryID();
    await this.fetchData();
  },
  methods: {
    async cancelApproveTeach_id(item) {
      let textAlert = item.mt_id_card;
      Swal.fire({
        title: "ต้องการยกเลิกรายการนี้",
        text: textAlert,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          let payload = {
            id_card: item.mt_id_card
          };

          try {
            let result = await this.$http.post(
              "personnel_temporary.update.level1_backward.php",
              {
                ApiKey: this.ApiKey,
                data: payload
              }
            );
              
            if (result.data.status === true) {
              Swal.fire({
                icon: "success",
                title: "ดำเนินการเรียบร้อย",
                showConfirmButton: false,
                timer: 1500
              });
              await this.fetchData();
            } else {
              Swal.fire({
                icon: "error",
                title: "ไม่สามารถอัปเดตข้อมูลได้",
                text: `อัปเดตสำเร็จ ${result.data.updated || 0} รายการ`
              });
            }
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาดในการเชื่อมต่อ API"
            });
          }
        }
      });
    },

    async viewFileleavegurantee(assistant_teacher_re_leaveguarantee) {
      this.assistant_teacher_re_leaveguarantee = assistant_teacher_re_leaveguarantee;
      this.assistant_teacher_re_leaveguaranteedialog = true;
    },

    async viewFileScore(param) {
      this.assFileScore = param;
      this.scoredialog = true;
    },

    async viewpdflicenseteach(pt_licence_file) {
      this.pt_licence_files = pt_licence_file;
      let pt_licence_fileCk = String(pt_licence_file);
      if (pt_licence_fileCk.length > 4) {
        this.pdflicenseteachdialog = true;
      } else {
        Swal.fire({
          icon: "warning",
          title: "ไม่ได้แนบไฟล์",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    async userQueryID() {
      let result;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_ID: userSession.user_ID
      });
      this.user_id = result.data;
    },

    async fetchData() {
      try {
        this.loading = true;
        await this.fetchAssistantTeachers();
        this.updateCharts();
      } catch (error) {
        console.error("Error fetching data:", error);
        // Use mock data for demo
        this.assistantTeachers = [];
        this.updateCharts();
      } finally {
        this.loading = false;
      }
    },
    async fetchAssistantTeachers() {
      const response = await this.$http.post(
        "manage_assistant_teacher_backup.php",
        {
          ApiKey: this.ApiKey
        }
      );
      this.assistantTeachers = response.data;
    },
    updateCharts() {
      // Update status chart
      const statusCounts = [0, 0, 0];
      this.assistantTeachers.forEach(teacher => {
        if (teacher.mt_status === "1") statusCounts[0]++;
        else if (teacher.mt_status === "0") statusCounts[1]++;
        else statusCounts[2]++;
      });
      this.statusChartSeries = statusCounts;

      // Update education chart
      const educationCounts = [0, 0, 0, 0];
      this.assistantTeachers.forEach(teacher => {
        if (teacher.mt_ed_abb && teacher.mt_ed_abb.includes("บ."))
          educationCounts[0]++;
        else if (teacher.mt_ed_abb && teacher.mt_ed_abb.includes("ม."))
          educationCounts[1]++;
        else if (teacher.mt_ed_abb && teacher.mt_ed_abb.includes("ด."))
          educationCounts[2]++;
        else educationCounts[3]++;
      });
      this.educationChartSeries = educationCounts;

      // Update appointment trend chart
      const yearCounts = {};
      this.assistantTeachers.forEach(teacher => {
        const year = teacher.mt_appoin_year || 2023;
        yearCounts[year] = (yearCounts[year] || 0) + 1;
      });

      const years = Object.keys(yearCounts).sort();
      const counts = years.map(year => yearCounts[year]);

      this.appointmentTrendOptions = {
        ...this.appointmentTrendOptions,
        xaxis: {
          categories: years
        }
      };
      this.appointmentTrendSeries = [
        {
          name: "การแต่งตั้ง",
          data: counts
        }
      ];
    },
    getStatusColor(status) {
      switch (status) {
        case "1":
          return "success";
        case "0":
          return "error";
        default:
          return "warning";
      }
    },
    getStatusText(status) {
      switch (status) {
        case "1":
          return "ใช้งาน";
        case "0":
          return "ไม่ใช้งาน";
        default:
          return "รอดำเนินการ";
      }
    },
    viewDetails(item) {
      this.selectedTeacher = item;
      this.detailsDialog = true;
    },
    applyFilters() {
      this.fetchData();
    },
    clearFilters() {
      this.filters = {
        mt_appoin_day: null,
        mt_appoin_month: null,
        mt_appoin_year: null,
        mt_id_card: null,
        mt_type_personnel: null
      };
      this.fetchData();
    },
    editItem(item) {
    }
  }
};
</script>

<style scoped>
.v-card-title {
  font-weight: bold;
}
.text-h4 {
  font-weight: bold;
}
</style>
